/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Email_TemplateInputs */

const cs_automation_email_template = /** @type {(inputs: Automation_Email_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailová šablona`)
};

const en_automation_email_template = /** @type {(inputs: Automation_Email_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email template`)
};

/**
* | output |
* | --- |
* | "Email template" |
*
* @param {Automation_Email_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_email_template = /** @type {((inputs?: Automation_Email_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Email_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_email_template(inputs)
	return cs_automation_email_template(inputs)
});